export const checkSchemaReady = (schema: JSONSchema | null | undefined, values: Record<string, any>): boolean => {
  if (!schema) return false;
  const required = (schema?.required ?? []) as string[];
  if (required.length === 0) return true;
  return required.every((key) => {
    const val = values?.[key];
    const propDef = (schema?.properties as any)?.[key];
    if (val === null || val === undefined || val === '') return false;
    if (typeof val === 'string' && propDef?.minLength) return val.length >= propDef.minLength;
    if (typeof val === 'object' && val !== null && propDef?.minProperties) {
      return Object.keys(val).length >= propDef.minProperties;
    }
    return true;
  });
};

export const mergeSchemas = (schemas: Array<JSONSchema | null | undefined>): JSONSchema => {
  const mergedProperties: Record<string, any> = {};
  const mergedRequired = new Set<string>();
  schemas.forEach((schema) => {
    Object.entries(schema?.properties ?? {}).forEach(([key, def]: [string, any]) => {
      if (!(key in mergedProperties)) {
        mergedProperties[key] = def;
      }
    });
    (schema?.required ?? []).forEach((key: string) => mergedRequired.add(key));
  });
  return {
    type: 'object',
    properties: mergedProperties,
    ...(mergedRequired.size > 0 && { required: Array.from(mergedRequired) }),
  };
};
